module.exports = __webpack_public_path__ + "media/images/mailer/logo_icon-white-0e879c4d96df6c174bdd574dc9429c36.png";